/*  THE UPGRADE OFFER. Interrupts the buy button once, on products that name a bundle.

    WHY THIS AND NOT A REDIRECT: the old site sent buyers to the bundle's product page
    instead of to checkout. That is a full page load away from the thing they had just
    chosen, and the only way back is the back button, which is also the way out of the
    purchase. This asks the question without moving anybody.

    IT FAILS TOWARDS THE SALE, every time. No panel, a network error, a missing variant,
    a second click: the form submits and the buyer reaches checkout with the product they
    picked. The offer is worth money, but never more than the purchase it is attached to,
    so every branch that cannot complete falls through to the plain checkout.

    SHOWN ONCE PER PAGE. Answering it and pressing buy again does not ask twice.

    EVERY BUY FORM ON THE PAGE, NOT THE FIRST ONE. This used to call querySelector, which
    returns a single element, so it bound the hero form and nothing else. A kit page has
    two: the hero, and the one in the closing section at the bottom. The bottom button is
    the one a buyer reaches after reading the whole page and listening to the previews,
    which makes it the likeliest button on the page to be pressed, and it went straight
    to checkout without ever showing the offer. The bug was invisible from the top of the
    page, where the offer worked perfectly.

    THE FORM THAT ASKED IS THE FORM THAT SUBMITS. proceed() used to submit the one form
    this held. With several forms bound it has to submit the one the buyer actually used,
    or somebody pressing buy at the bottom and declining the offer would be checked out
    by a form at the top of the page. They carry the same variant today, so it would
    happen to work, and it would stop working the moment any page offers a choice.

    THE STICKY BUY BAR NEEDS NOTHING HERE. It forwards its click into the hero's button
    rather than carrying a form of its own, precisely so it cannot drift from this.

    ev-buy.js also binds to buy buttons on the landing page. It is not loaded on the
    product templates, so there is no second handler racing this one.  */
(function () {
  var panel = document.getElementById('evUpsell');
  if (!panel) return;

  var forms = document.querySelectorAll('form.ev-pd-buy');
  if (!forms.length) return;

  var answered = false;
  var lastFocus = null;
  var pending = null;   /* the form whose button was pressed */

  function open () {
    lastFocus = document.activeElement;
    panel.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var yes = panel.querySelector('[data-ev-up-take]');
    if (yes) yes.focus();
    document.addEventListener('keydown', onKey);
  }

  function close () {
    panel.hidden = true;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey (e) {
    if (e.key === 'Escape') close();
  }

  /*  Straight to checkout with what they already chose. answered stops the handler
      re-opening the panel when the click is replayed as a submit.  */
  function proceed () {
    answered = true;
    close();
    var f = pending || forms[0];
    if (f.requestSubmit) f.requestSubmit();
    else f.submit();
  }

  Array.prototype.forEach.call(forms, function (form) {
    form.addEventListener('submit', function (e) {
      if (answered) return;
      e.preventDefault();
      pending = form;
      open();
    });
  });

  panel.addEventListener('click', function (e) {
    if (e.target.closest('[data-ev-up-close]')) { close(); return; }
    if (e.target.closest('[data-ev-up-skip]')) { proceed(); return; }

    var take = e.target.closest('[data-ev-up-take]');
    if (!take) return;

    var variant = panel.getAttribute('data-bundle-variant');
    if (!variant) { proceed(); return; }

    take.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        /*  Could not add the bundle. Do not strand them in a dead panel: send them to
            the bundle's own page, where there is a working buy button.  */
        var url = panel.getAttribute('data-bundle-url');
        take.removeAttribute('aria-busy');
        if (url) window.location.href = url;
        else proceed();
      });
  });
})();
